// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[0]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[1]!../../../../../node_modules/@fortawesome/fontawesome-pro/css/all.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[0]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[1]!../../../../../node_modules/@angular/material/prebuilt-themes/deeppurple-amber.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FONTS */
.cdk-global-overlay-wrapper,
.cdk-overlay-container {
  z-index: 1100 !important;
}
/* VARIABLES */
/* ELEMENTS */
body {
  font: 14px/1.2 "Source Sans Pro", sans-serif;
  background: #efeff7;
}
h1 {
  background: linear-gradient(to bottom, #dcdbed, #f2f1f9);
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  padding: 15px;
  border-bottom: 1px solid #d8d9ea;
  margin-bottom: 0;
}
h2 {
  background: white;
  margin: 0;
  padding: 15px;
  font-size: 18px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
h2 i {
  color: #a29ffa;
  padding-right: 5px;
}
h2.filter-title {
  background: whitesmoke;
  cursor: pointer;
}
h2.filter-title input:first-of-type {
  margin-left: 20px;
}
h4 {
  font-size: 14px;
  font-weight: 700;
}
a {
  color: #5484ff;
  text-decoration: none;
}
a:hover {
  color: #5484ff;
  text-decoration: none;
}
/* MODULES */
mat-slide-toggle {
  margin: auto;
}
app-clients-add .form-group,
app-screening .form-group {
  margin-bottom: 5px;
}
app-clients-add .form-group label,
app-screening .form-group {
  text-align: right;
}
/* FORM ELEMENTS */
form {
  background: white;
  padding-bottom: 20px;
  font-weight: 400;
}
input[type="text"],
input[type="password"],
input[type="number"],
input[type="date"],
select,
textarea {
  font-size: 1rem;
  font-weight: 400;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
}
input[type="text"][required],
input[type="password"][required],
input[type="number"][required],
input[type="date"][required],
select[required],
textarea[required] {
  border-left: 5px solid #ce6161;
}
input[type="text"].sorta-required,
input[type="password"].sorta-required,
input[type="number"].sorta-required,
input[type="date"].sorta-required,
select.sorta-required,
textarea.sorta-required {
  border-left: 5px solid #54a54e;
}
input[type="text"]::placeholder,
input[type="password"]::placeholder,
input[type="number"]::placeholder,
input[type="date"]::placeholder {
  color: #8e9bb5;
}
button,
input[type="button"] {
  background: #c1bffb;
  padding: 5px 25px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 50px;
  border: 0px;
  transition: 0.5s;
  box-shadow: 1px 2px 3px #89889c;
  margin: 5px;
  outline: none !important;
}
button.brblue,
input[type="button"].brblue {
  background: #5484ff;
  color: white;
}
button.mdgrey,
input[type="button"].mdgrey {
  background: #716f7a;
  color: white;
}
button:hover,
input[type="button"]:hover {
  background: #a29ffa;
}
button.small,
input[type=button].small {
  margin: 0 5px;
  padding: 2px 8px;
  font-size: 12px;
}
.form-control-xs {
  height: calc(0.8em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 0.8;
  border-radius: 0.2rem;
}
.input-group .fa-asterisk {
  padding: 3px;
  font-size: 8px;
  background: #dedefd;
  color: #43425d;
  border: 1px solid #ced4da;
  border-right: 0;
  border-radius: 0.25rem 0 0 0.25rem;
}
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append > .input-group-text {
  height: calc(1.5em + 0.5rem + 2px);
}
.mat-slide-toggle-content {
  font-weight: 700;
  color: #a29ffa;
}
.invalid-feedback {
  display: block;
  border: 1px solid #ce6161;
  border-radius: 3px;
  background: rgba(220, 0, 0, 0.1);
  margin-top: 0;
  margin-bottom: 0.6rem;
  color: #ce6161;
  font-size: 100%;
  padding: 5px;
  margin-left: 15px;
  margin-right: 15px;
}
.invalid-feedback:after {
  font-family: 'Font Awesome 5 Pro', sans-serif;
  font-weight: 900;
  float: right;
  content: "\\f0aa";
}
/* GRIDS */
.grid {
  display: grid;
  grid-auto-columns: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 0 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding-top: 20px;
}
.table-header {
  font-weight: 600;
  padding: 7px 5px;
  color: #4b58a6;
}
.table-data,
.table-blank {
  border-top: 1px solid #e7ebeb;
  padding: 7px 5px;
  align-content: center;
  align-items: center;
}
.table-data.link {
  color: #5484ff;
  cursor: pointer;
}
.table-blank {
  border-top: 0;
}
.grid i {
  font-size: 16px;
  display: inline-block;
}
.grid i.fa-link,
i.fa-unlink,
i.fa-edit,
i.fa-trash,
i.fa-sync,
i.fa-donate,
i.fa-window-close,
i.fa-envelope-open-text,
i.fa-folder-upload,
i.fa-share-square,
i.fa-contao,
i.fa-file-download,
i.fa-envelope,
i.fa-print,
i.fa-flag,
i.fa-sticky-note,
i.fa-file-check,
i.fa-exclamation,
i.fa-grimace,
i.fa-plus-square,
i.fa-arrow-alt-circle-down,
i.fa-exchange-alt,
i.fa-skull,
i.fa-bell,
i.fa-arrows,
i.fa-rotate,
i.fa-rotate-daveRocks,
i.fa-save,
i.fa-credit-card {
  color: #5484ff;
  cursor: pointer;
  margin: 1px;
  display: inline;
}
.grid .action-icons i {
  margin-right: 15px;
  color: #5484ff;
  cursor: pointer;
}
.grid .action-icons i.red {
  color: #ce6161;
}
.grid i.fas.fa-check {
  color: #54a54e;
}
.grid.info {
  padding: 20px 10px;
  width: 50%;
  float: left;
  grid-template-columns: repeat(2, auto);
}
.grid.info .table-header {
  text-align: right;
}
.grid.info .table-header:after {
  content: ':';
}
.grid.info .table-data,
.grid.notes-form .table-data {
  border-top: 0;
}
/* FILTERS */
.grid.filters {
  height: auto;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d8d9ea;
  grid-row-gap: 12px;
}
.grid.filters input[type="text"],
.grid.filters input[type="password"],
.grid.filters input[type="number"],
.grid.filters input[type="date"],
.grid.filters textarea {
  border-width: 0;
  border-bottom-width: 1px;
  font-size: 1rem;
  font-weight: 400;
  height: 1.8rem;
  border-color: #8e9bb5;
  transition: 0.15s ease-in-out;
  outline: none;
  width: 95%;
  border-radius: 3px 3px 0 0;
  padding: 3px;
}
.grid.filters input[type="text"]:focus,
.grid.filters input[type="password"]:focus,
.grid.filters input[type="number"]:focus,
.grid.filters input[type="date"]:focus,
.grid.filters textarea:focus {
  border-color: #a29ffa;
  background: whitesmoke;
}
.grid.filters label {
  margin-bottom: 3px;
  font-weight: 400;
  font-size: 12px;
  padding-left: 3px;
  color: #716f7a;
  display: block;
}
.grid.filters .datepicker input {
  margin-bottom: 8px;
  text-align: center;
}
.grid.filters .datepicker select {
  margin-left: 5px;
}
.grid.filters .table-data {
  border: 0;
}
#results-pane,
.results-pane {
  background: whitesmoke;
  padding: 15px;
  border-top: 1px solid #d8d9ea;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#results-pane .records-page,
.results-pane .records-page {
  width: auto;
  float: right;
  font-size: 12px;
}
#results-pane select,
.results-pane select {
  display: inline;
  width: auto;
}
.paginate-button-panel {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paginate-button-panel i {
  color: #5484ff;
  font-size: 24px;
  padding: 0 10px;
  cursor: pointer;
}
.paginate-button-panel .current-page {
  font-size: 16px;
  line-height: 24px;
  padding: 0 8px;
  margin: 0 4px;
  border-radius: 20px;
  background: lightgrey;
  color: grey;
  width: 26px;
  height: 26px;
  text-align: center;
}
.highlight-this {
  background-color: yellow !important;
}
/* COLOR MARKERS */
.brblue {
  color: #5484ff;
}
.brpurple {
  color: #a29ffa;
}
.dkgrey {
  color: #43425d;
}
.grey {
  color: #8e9bb5;
}
.green {
  color: #54a54e;
}
.yellow {
  color: #e2b94f;
}
.orange {
  color: #d88949;
}
.red {
  color: #ce6161;
}
.teal {
  color: #379dac;
}
/* SIZE MARKERS */
.text-sm {
  font-size: 11px;
}
.text-lg {
  font-size: 16px;
}
.text-90 {
  font-size: 90%;
}
.text-80 {
  font-size: 80%;
}
/* WEIGHT MARKERS */
.bold {
  font-weight: 700;
}
/* ALIGNMENT MARKERS */
.left {
  text-align: left;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
/* ResidentIQ */
.riq {
  display: inline-block;
  border-radius: 5px;
  background: #a4a3be;
  color: white;
  font-weight: 500;
  cursor: default;
  padding: 2px 5px;
}
.riq i {
  padding-right: 3px;
  font-size: 12px;
}
.riq.decline {
  background: #ce6161;
}
.riq.conditional-low {
  background: #d88949;
}
.riq.conditional-high {
  background: #e2b94f;
}
.riq.accept {
  background: #54a54e;
}
::ng-deep .tooltip-inner {
  background-color: #43425d;
}
::ng-deep .bs-tooltip-bottom .arrow:before {
  border-bottom-color: #43425d;
}
/* NOTES */
input[type="button"].note-changes,
button.note-changes {
  background: #3e73c9;
  color: white;
}
input[type="button"].note-setup,
button.note-setup {
  background: #379dac;
  color: white;
}
input[type="button"].note-checkin,
button.note-checkin {
  background: #6c6c6c;
  color: white;
}
input[type="button"].note-pastdue,
button.note-pastdue {
  background: #ce6161;
  color: white;
}
input[type="button"].note-payment,
button.note-payment {
  background: #54a54e;
  color: white;
}
input[type="button"].note-disabled,
button.note-disabled {
  background: #43425d;
  color: white;
}
input[type="button"].note-preguntas,
button.note-preguntas {
  background: #a29ffa;
  color: white;
}
input[type="button"].note-rerun,
button.note-rerun {
  background: #d88949;
  color: white;
}
input[type="button"].note-refund,
button.note-refund {
  background: #e2b94f;
  color: white;
}
input[type="button"].note-review,
button.note-review {
  background: #b1639f;
  color: white;
}
input[type="button"].note-label,
.note-label {
  color: white;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 400;
  margin: 3px;
  box-shadow: none;
}
input[type="button"].note-label.note-changes,
.note-label.note-changes {
  background: #3e73c9;
}
input[type="button"].note-label.note-setup,
.note-label.note-setup {
  background: #379dac;
}
input[type="button"].note-label.note-checkin,
.note-label.note-checkin {
  background: #6c6c6c;
}
input[type="button"].note-label.note-pastdue,
.note-label.note-pastdue {
  background: #ce6161;
}
input[type="button"].note-label.note-payment,
.note-label.note-payment {
  background: #54a54e;
}
input[type="button"].note-label.note-disabled,
.note-label.note-disabled {
  background: #43425d;
}
input[type="button"].note-label.note-preguntas,
.note-label.note-preguntas {
  background: #a29ffa;
}
input[type="button"].note-label.note-rerun,
.note-label.note-rerun {
  background: #d88949;
}
input[type="button"].note-label.note-refund,
.note-label.note-refund {
  background: #e2b94f;
}
input[type="button"].note-label.note-review,
.note-label.note-review {
  background: #b1639f;
}
i.note-changes {
  color: #3e73c9;
}
i.note-setup {
  color: #379dac;
}
i.note-checkin {
  color: #6c6c6c;
}
i.note-pastdue {
  color: #ce6161;
}
i.note-payment {
  color: #54a54e;
}
i.note-disabled {
  color: #43425d;
}
i.note-preguntas {
  color: #a29ffa;
}
i.note-rerun {
  color: #d88949;
}
i.note-refund {
  color: #e2b94f;
}
i.note-review {
  color: #b1639f;
}
/* MISCELLANEOUS */
.collapse-link {
  font-size: 12px;
  font-weight: 700;
  color: #5484ff;
}
/* PRINT STYLES */
@media print {
  body {
    background: white !important;
  }
  header {
    position: relative !important;
  }
  nav,
  .logo-holder img,
  .search-bar,
  .quick-nav {
    display: none;
  }
  main {
    left: 0 !important;
    width: 100% !important;
  }
  .logo-holder {
    background: url('ResIQ_Logo_Grey.359a4bddb741e95b.png') no-repeat center white !important;
    background-size: contain !important;
    margin-left: 10px;
  }
  .w-container {
    max-width: 100% !important;
  }
  .screening-report .header {
    border-width: 5px 0px !important;
    border-color: black !important;
    border-style: solid !important;
    background: none !important;
    color: black !important;
  }
  h4 {
    padding-left: 20px !important;
    border-bottom: 1px solid black !important;
    background: none !important;
    color: black !important;
  }
  h5 {
    background: #efefef !important;
  }
}
app-address-input {
  width: 100%;
}
@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
    color: rgba(127, 230, 118, 0.9);
    text-shadow: 0px 0px 20px #12a105;
  }
  100% {
    opacity: 1;
    color: black;
  }
}
.pulsing {
  animation: pulse 3s;
  animation-direction: alternate;
}
.residentIQ {
  animation: pulse 3s;
  animation-direction: alternate;
}
.form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  padding-left: 15px;
}
@keyframes sop-highlight-glow {
  0%,
  100% {
    box-shadow: 0 0 15px 12px rgba(29, 0, 249, 0.3);
  }
  50% {
    box-shadow: 0 0 36px 13px rgba(29, 0, 249, 0.8);
  }
}
@keyframes sop-highlight-fade-in {
  from {
    opacity: 0;
    outline-color: transparent;
    box-shadow: none;
  }
  to {
    opacity: 1;
  }
}
@keyframes sop-highlight-fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    outline-color: transparent;
    box-shadow: none;
  }
}
.sop-highlight {
  animation: sop-highlight-fade-in 0.4s ease-out, sop-highlight-glow 1s ease-in-out 0.4s infinite;
  outline: 2px solid rgba(124, 109, 240, 0.7);
  outline-offset: 2px;
  border-radius: 4px;
}
.sop-highlight-out {
  animation: sop-highlight-fade-out 0.5s ease-in forwards;
  outline: 2px solid rgba(124, 109, 240, 0.7);
  outline-offset: 2px;
  border-radius: 4px;
}
.scrollable {
  max-height: 700px;
  height: auto;
  overflow-y: auto;
}
.scrollable th {
  text-align: left;
  z-index: 1;
  top: 0;
  position: sticky;
  background-color: white;
}
table {
  width: 99%;
}
table.center {
  text-align: center;
}
th {
  font-weight: 600;
  padding: 7px 5px;
  color: #4b58a6;
}
tr {
  border-bottom: 1px solid #e7ebeb;
  margin: 1%;
}
tr td {
  padding: 0.3%;
}
tr.invalid {
  background-color: #ce6161;
}
.grid.emails-all {
  grid-template-columns: repeat(8, auto);
}
.grid.emails-single {
  grid-template-columns: repeat(8, auto);
}
.grid.filters {
  grid-template-columns: repeat(3, 1fr);
}
.red-row {
  background-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/email-queue/screening-emails/screening-emails.component.less","webpack://./src/BootstrapMaterialOverride.less","webpack://./src/styles.less","webpack://./src/assets/tables.less"],"names":[],"mappings":"AAAA,UAAU;ACEV;;EACE,wBAAA;ADGF;AACA,cAAc;AACd,aAAa;AEsCb;EACI,4CAAA;EACA,mBAAA;AFpCJ;AEsCA;EACI,wDAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,gBAAA;AFpCJ;AEsCA;EACI,iBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AFpCJ;AEsCA;EACI,cAAA;EACA,kBAAA;AFpCJ;AEsCA;EACI,sBAAA;EACA,eAAA;AFpCJ;AEsCA;EACI,iBAAA;AFpCJ;AEsCA;EACE,eAAA;EACA,gBAAA;AFpCF;AEsCA;EACI,cAAA;EACA,qBAAA;AFpCJ;AEsCA;EACI,cAAA;EACA,qBAAA;AFpCJ;AACA,YAAY;AEuCZ;EACE,YAAA;AFrCF;AEwCA;;EACE,kBAAA;AFrCF;AEuCA;;EACE,iBAAA;AFpCF;AACA,kBAAkB;AEuClB;EACI,iBAAA;EACA,oBAAA;EACA,gBAAA;AFrCJ;AEuCA;;;;;;EACI,eAAA;EACA,gBAAA;EACA,wEAAA;EACA,aAAA;AFhCJ;AEiCI;;;;;;EACE,8BAAA;AF1BN;AE4BI;;;;;;EAEE,8BAAA;AFtBN;AEyBA;;;;EACI,cAAA;AFpBJ;AEsBA;;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,wBAAA;AFnBJ;AEqBA;;EACI,mBAAA;EACA,YAAA;AFlBJ;AEoBA;;EACI,mBAAA;EACA,YAAA;AFjBJ;AEmBA;;EACI,mBAAA;AFhBJ;AEkBA;;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AFfJ;AEiBA;EACE,kCAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AFfF;AEiBA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kCAAA;AFfJ;AEiBA;;EACE,kCAAA;AFdF;AEgBA;EACE,gBAAA;EACA,cAAA;AFdF;AEgBA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AFdF;AEgBA;EACE,6CAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AFdF;AACA,UAAU;AEiBV;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;AFfJ;AEiBA;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;AFfJ;AEiBA;;EACI,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AFdJ;AEgBA;EACE,cAAA;EACA,eAAA;AFdF;AEgBA;EACE,aAAA;AFdF;AEgBA;EACI,eAAA;EACA,qBAAA;AFdJ;AEgBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BI,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AFdJ;AEgBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AFdF;AEgBA;EACE,cAAA;AFdF;AEiBA;EACE,cAAA;AFfF;AEiBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;AFfF;AEiBA;EAiKI,iBAAA;AF/KJ;AEiBA;EACE,YAAA;AFfF;AEiBA;;EACE,aAAA;AFdF;AACA,YAAY;AEkBZ;EACI,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AFhBJ;AEUA;;;;;EAQM,eAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;AFXN;AEPA;;;;;EAqBM,qBAAA;EACA,sBAAA;AFPN;AEUA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AFRJ;AEUA;EACE,kBAAA;EACA,kBAAA;AFRF;AEUA;EACE,gBAAA;AFRF;AEUA;EACI,SAAA;AFRJ;AEWA;;EACI,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AFRJ;AEWA;;EACI,WAAA;EACA,YAAA;EACA,eAAA;AFRJ;AEWA;;EACI,eAAA;EACA,WAAA;AFRJ;AEWA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFTJ;AEWA;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AFTJ;AEWA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AFTF;AEYA;EACE,mCAAA;AFVF;AACA,kBAAkB;AEalB;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AEaA;EACI,cAAA;AFXJ;AACA,iBAAiB;AEcjB;EACI,eAAA;AFZJ;AEcA;EACI,eAAA;AFZJ;AEcA;EACE,cAAA;AFZF;AEcA;EACE,cAAA;AFZF;AACA,mBAAmB;AEenB;EACI,gBAAA;AFbJ;AACA,sBAAsB;AEgBtB;EACI,gBAAA;AFdJ;AEgBA;EACI,kBAAA;AFdJ;AEgBA;EACI,iBAAA;AFdJ;AACA,eAAe;AEiBf;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AFfJ;AEiBA;EACI,kBAAA;EACA,eAAA;AFfJ;AEiBA;EACI,mBAAA;AFfJ;AEiBA;EACI,mBAAA;AFfJ;AEiBA;EACI,mBAAA;AFfJ;AEiBA;EACI,mBAAA;AFfJ;AEiBA;EAEQ,yBAAA;AFhBR;AEcA;EAKQ,4BAAA;AFhBR;AACA,UAAU;AEqBR;;EACE,mBAAA;EACA,YAAA;AFlBJ;AEoBE;;EACE,mBAAA;EACA,YAAA;AFjBJ;AEmBE;;EACE,mBAAA;EACA,YAAA;AFhBJ;AEkBE;;EACE,mBAAA;EACA,YAAA;AFfJ;AEiBE;;EACE,mBAAA;EACA,YAAA;AFdJ;AEgBE;;EACE,mBAAA;EACA,YAAA;AFbJ;AEeE;;EACE,mBAAA;EACA,YAAA;AFZJ;AEcE;;EACE,mBAAA;EACA,YAAA;AFXJ;AEaE;;EACE,mBAAA;EACA,YAAA;AFVJ;AEYE;;EACE,mBAAA;EACA,YAAA;AFTJ;AEaA;;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AFVF;AEWE;;EACE,mBAAA;AFRJ;AEUE;;EACE,mBAAA;AFPJ;AESE;;EACE,mBAAA;AFNJ;AEQE;;EACE,mBAAA;AFLJ;AEOE;;EACE,mBAAA;AFJJ;AEME;;EACE,mBAAA;AFHJ;AEKE;;EACE,mBAAA;AFFJ;AEIE;;EACE,mBAAA;AFDJ;AEGE;;EACE,mBAAA;AFAJ;AEEE;;EACE,mBAAA;AFCJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AEIE;EACE,cAAA;AFFJ;AACA,kBAAkB;AEMlB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AFJJ;AACA,iBAAiB;AEOjB;EACE;IACE,4BAAA;EFLF;EEOA;IACE,6BAAA;EFLF;EEOA;;;;IACE,aAAA;EFFF;EEIA;IACE,kBAAA;IACA,sBAAA;EFFF;EEIA;IACE,yFAAA;IACA,mCAAA;IACA,iBAAA;EFFF;EEIA;IACE,0BAAA;EFFF;EEIA;IACE,gCAAA;IACA,8BAAA;IACA,8BAAA;IACA,2BAAA;IACA,uBAAA;EFFF;EEIA;IACE,6BAAA;IACA,yCAAA;IACA,2BAAA;IACA,uBAAA;EFFF;EEIA;IACE,8BAAA;EFFF;AACF;AEKA;EACE,WAAA;AFHF;AEyBA;EACE;IACI,YAAA;EFvBJ;EEyBA;IACI,UAAA;IACA,+BAAA;IACA,iCAAA;EFvBJ;EEyBA;IACI,UAAA;IACA,YAAA;EFvBJ;AACF;AE0BA;EACE,mBAAA;EACA,8BAAA;AFxBF;AE0BA;EAHE,mBAAA;EACA,8BAAA;AFpBF;AE0BA;EACE,iCAAA;EACA,oCAAA;EACA,kBAAA;AFxBF;AE4BA;EACE;;IAAW,+CAAA;EFxBX;EEyBA;IAAW,+CAAA;EFtBX;AACF;AEwBA;EACE;IAAO,UAAA;IAAY,0BAAA;IAA4B,gBAAA;EFnB/C;EEoBA;IAAO,UAAA;EFjBP;AACF;AEmBA;EACE;IAAO,UAAA;EFhBP;EEiBA;IAAO,UAAA;IAAY,0BAAA;IAA4B,gBAAA;EFZ/C;AACF;AEcA;EACE,+FAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AFZF;AEeA;EACE,uDAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AFbF;AGnsBA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;AHqsBJ;AGxsBA;EAKQ,gBAAA;EACA,UAAA;EACA,MAAA;EACA,gBAAA;EACA,uBAAA;AHssBR;AGlsBA;EACI,UAAA;AHosBJ;AGnsBI;EACI,kBAAA;AHqsBR;AGlsBA;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;AHosBJ;AGlsBA;EACI,gCAAA;EACA,UAAA;AHosBJ;AGtsBA;EAIQ,aAAA;AHqsBR;AGnsBI;EACI,yBAAA;AHqsBR;AAvuBA;EACI,sCAAA;AAyuBJ;AAvuBA;EACI,sCAAA;AAyuBJ;AApuBA;EACI,qCAAA;AAsuBJ;AAnuBA;EACI,qBAAA;AAquBJ","sourcesContent":["@import '../../../../styles.less';\n@import '../../../../assets/tables.less';\n\n.grid.emails-all {\n    grid-template-columns: repeat(8, auto);\n}\n.grid.emails-single {\n    grid-template-columns: repeat(8, auto);\n}\n.msg {\n    \n}\n.grid.filters {\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.red-row {\n    background-color: red;\n}","\n// This will override the material select dropdown being rendered behind the bootstrap modal overlay\n.cdk-global-overlay-wrapper, .cdk-overlay-container {\n  z-index: 1100 !important;\n}\n","/* FONTS */\n@import (css) \"~@fortawesome/fontawesome-pro/css/all.css\";\n@import (css) \"~@angular/material/prebuilt-themes/deeppurple-amber.css\";\n\n// Import the bootstrap angular material overridesz\n@import \"BootstrapMaterialOverride\";\n\n/* VARIABLES */\n@sdpurple: #3c3c54;\n@dkpurple: #43425d;\n@mdpurple: #4b58a6;\n@brpurple: #a29ffa;\n@plpurple: #dedefd;\n@ltpurple: #efeff7;\n@dkblue: #0f1a35;\n@mdblue: #1e305e;\n@brblue: #5484ff;\n@skyblue: #4297d5;\n@dkgrey: #43425d;\n@mdgrey: #716f7a;\n@grey: #8e9bb5;\n@ltgrey: #a4a3be;\n@yellow: #e2b94f;\n@green: #54a54e;\n@orange: #d88949;\n@red: #ce6161;\n@teal: #379dac;\n@dkteal: #36577b;\n\n@dropshadow: #89889c;\n@darkshadow: black;\n@overlay: rgba(15,26,53,0.3);\n@header-height: 70px;\n@sidebar-width: 220px;\n@sidebar-color: @dkblue;\n@logo-holder: @dkblue;\n@profile-link: @dkblue;\n@profile-hover: @mdblue;\n@grid-row: rgba(whitesmoke, 0.3);\n@button: #c1bffb;\n@button-drop: 1px 2px 3px;\n@grid: #e7ebeb;\n@h1-gradient: linear-gradient(to bottom, #dcdbed, #f2f1f9);\n@h1-bottom: #d8d9ea;\n\n/* ELEMENTS */\nbody {\n    font: 14px/1.2 \"Source Sans Pro\", sans-serif;\n    background: @ltpurple;\n}\nh1 {\n    background: @h1-gradient;\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 600;\n    padding: 15px;\n    border-bottom: 1px solid @h1-bottom;\n    margin-bottom: 0;\n}\nh2 {\n    background: white;\n    margin: 0;\n    padding: 15px;\n    font-size: 18px;\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\nh2 i {\n    color: @brpurple;\n    padding-right: 5px;\n}\nh2.filter-title {\n    background: whitesmoke;\n    cursor: pointer;\n}\nh2.filter-title input:first-of-type {\n    margin-left: 20px;\n}\nh4 {\n  font-size: 14px;\n  font-weight: 700;\n}\na {\n    color: @brblue;\n    text-decoration: none;\n}\na:hover {\n    color: @brblue;\n    text-decoration: none;\n}\n\n/* MODULES */\nmat-slide-toggle {\n  margin: auto;\n}\n\napp-clients-add .form-group, app-screening .form-group {\n  margin-bottom: 5px;\n}\napp-clients-add .form-group label, app-screening .form-group {\n  text-align: right;\n}\n\n/* FORM ELEMENTS */\nform {\n    background: white;\n    padding-bottom: 20px;\n    font-weight: 400;\n}\ninput[type=\"text\"], input[type=\"password\"], input[type=\"number\"], input[type=\"date\"], select, textarea {\n    font-size: 1rem;\n    font-weight: 400;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    outline: none;\n    &[required] {\n      border-left: 5px solid @red;\n    }\n    &.sorta-required\n    {\n      border-left: 5px solid @green;\n    }\n}\ninput[type=\"text\"]::placeholder, input[type=\"password\"]::placeholder, input[type=\"number\"]::placeholder, input[type=\"date\"]::placeholder {\n    color: @grey;\n}\nbutton, input[type=\"button\"] {\n    background: @button;\n    padding: 5px 25px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 50px;\n    border: 0px;\n    transition: 0.5s;\n    box-shadow: @button-drop @dropshadow;\n    margin: 5px;\n    outline: none !important;\n}\nbutton.brblue, input[type=\"button\"].brblue {\n    background: @brblue;\n    color: white;\n}\nbutton.mdgrey, input[type=\"button\"].mdgrey {\n    background: @mdgrey;\n    color: white;\n}\nbutton:hover, input[type=\"button\"]:hover {\n    background: @brpurple;\n}\nbutton.small, input[type=button].small {\n    margin: 0 5px;\n    padding: 2px 8px;\n    font-size: 12px;\n}\n.form-control-xs {\n  height: calc(.8em + .5rem + 2px);\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  line-height: .8;\n  border-radius: .2rem;\n}\n.input-group .fa-asterisk {\n    padding: 3px;\n    font-size: 8px;\n    background: @plpurple;\n    color: @dkpurple;\n    border: 1px solid #ced4da;\n    border-right: 0;\n    border-radius: 0.25rem 0 0 0.25rem;\n}\n.input-group>.input-group-prepend>.input-group-text, .input-group>.input-group-append>.input-group-text {\n  height: calc(1.5em + .5rem + 2px);\n}\n.mat-slide-toggle-content {\n  font-weight: 700;\n  color: @brpurple;\n}\n.invalid-feedback {\n  display: block;\n  border: 1px solid @red;\n  border-radius: 3px;\n  background: rgba(220, 0, 0, 0.1);\n  margin-top: 0;\n  margin-bottom: .6rem;\n  color: @red;\n  font-size: 100%;\n  padding: 5px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.invalid-feedback:after {\n  font-family: 'Font Awesome 5 Pro', sans-serif;\n  font-weight: 900;\n  float: right;\n  content: \"\\f0aa\";\n}\n\n/* GRIDS */\n.grid {\n    display: grid;\n    grid-auto-columns: auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid @h1-bottom;\n    padding-top: 20px;\n}\n.table-header {\n    font-weight: 600;\n    padding: 7px 5px;\n    color: @mdpurple;\n}\n.table-data, .table-blank {\n    border-top: 1px solid @grid;\n    padding: 7px 5px;\n    align-content: center;\n    align-items: center;\n}\n.table-data.link {\n  color: @brblue;\n  cursor: pointer;\n}\n.table-blank {\n  border-top: 0;\n}\n.grid i {\n    font-size: 16px;\n    display: inline-block;\n}\n.grid i.fa-link,\ni.fa-unlink,\ni.fa-edit,\ni.fa-trash,\ni.fa-sync,\ni.fa-donate,\ni.fa-window-close,\ni.fa-envelope-open-text,\ni.fa-folder-upload,\ni.fa-share-square,\ni.fa-contao,\ni.fa-file-download,\ni.fa-envelope,\ni.fa-print,\ni.fa-flag,\ni.fa-sticky-note,\ni.fa-file-check,\ni.fa-exclamation,\ni.fa-grimace,\ni.fa-plus-square,\ni.fa-arrow-alt-circle-down,\ni.fa-exchange-alt,\ni.fa-skull,\ni.fa-bell,\ni.fa-arrows,\ni.fa-rotate,\ni.fa-rotate-daveRocks,\ni.fa-save,\ni.fa-credit-card {\n    color: @brblue;\n    cursor: pointer;\n    margin: 1px;\n    display: inline;\n}\n.grid .action-icons i {\n  margin-right: 15px;\n  color: @brblue;\n  cursor: pointer;\n}\n.grid .action-icons i.red {\n  color: @red;\n}\n\n.grid i.fas.fa-check {\n  color: @green;\n}\n.grid.info {\n  padding: 20px 10px;\n  width: 50%;\n  float: left;\n  grid-template-columns: repeat(2, auto);\n}\n.grid.info .table-header {\n  .right;\n}\n.grid.info .table-header:after {\n  content: ':';\n}\n.grid.info .table-data, .grid.notes-form .table-data {\n  border-top: 0;\n}\n\n\n/* FILTERS */\n.grid.filters {\n    height: auto;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid @h1-bottom;\n    grid-row-gap: 12px;\n    input[type=\"text\"], input[type=\"password\"], input[type=\"number\"], input[type=\"date\"],textarea {\n      border-width: 0;\n      border-bottom-width: 1px;\n      font-size: 1rem;\n      font-weight: 400;\n      height: 1.8rem;\n      border-color: @grey;\n      transition: 0.15s ease-in-out;\n      outline: none;\n      width: 95%;\n      border-radius: 3px 3px 0 0;\n      padding: 3px;\n    }\n    input[type=\"text\"]:focus, input[type=\"password\"]:focus, input[type=\"number\"]:focus, input[type=\"date\"]:focus, textarea:focus {\n      border-color: @brpurple;\n      background: whitesmoke;\n    }\n}\n.grid.filters label {\n    margin-bottom: 3px;\n    font-weight: 400;\n    font-size: 12px;\n    padding-left: 3px;\n    color: @mdgrey;\n    display: block;\n}\n.grid.filters .datepicker input {\n  margin-bottom: 8px;\n  text-align: center;\n}\n.grid.filters .datepicker select {\n  margin-left: 5px;\n}\n.grid.filters .table-data {\n    border: 0;\n}\n\n#results-pane, .results-pane {\n    background: whitesmoke;\n    padding: 15px;\n    border-top: 1px solid @h1-bottom;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n#results-pane .records-page, .results-pane .records-page{\n    width: auto;\n    float: right;\n    font-size: 12px;\n}\n\n#results-pane select, .results-pane select {\n    display: inline;\n    width: auto;\n}\n\n.paginate-button-panel {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.paginate-button-panel i {\n    color: @brblue;\n    font-size: 24px;\n    padding: 0 10px;\n    cursor: pointer;\n}\n.paginate-button-panel .current-page {\n  font-size: 16px;\n  line-height: 24px;\n  padding: 0 8px;\n  margin: 0 4px;\n  border-radius: 20px;\n  background: lightgrey;\n  color: grey;\n  width: 26px;\n  height: 26px;\n  text-align: center;\n}\n\n.highlight-this {\n  background-color: yellow !important;\n}\n\n/* COLOR MARKERS */\n.brblue {\n    color: @brblue;\n}\n.brpurple {\n    color: @brpurple;\n}\n.dkgrey {\n    color: @dkgrey;\n}\n.grey {\n    color: @grey;\n}\n.green {\n    color: @green;\n}\n.yellow {\n    color: @yellow;\n}\n.orange {\n    color: @orange;\n}\n.red {\n    color: @red;\n}\n.teal {\n    color: @teal;\n}\n\n/* SIZE MARKERS */\n.text-sm {\n    font-size: 11px;\n}\n.text-lg {\n    font-size: 16px;\n}\n.text-90 {\n  font-size: 90%;\n}\n.text-80 {\n  font-size: 80%;\n}\n\n/* WEIGHT MARKERS */\n.bold {\n    font-weight: 700;\n}\n\n/* ALIGNMENT MARKERS */\n.left {\n    text-align: left;\n}\n.center {\n    text-align: center;\n}\n.right {\n    text-align: right;\n}\n\n/* ResidentIQ */\n.riq {\n    display: inline-block;\n    border-radius: 5px;\n    background: @ltgrey;\n    color: white;\n    font-weight: 500;\n    cursor: default;\n    padding: 2px 5px;\n}\n.riq i {\n    padding-right: 3px;\n    font-size: 12px;\n}\n.riq.decline {\n    background: @red;\n}\n.riq.conditional-low {\n    background: @orange;\n}\n.riq.conditional-high {\n    background: @yellow;\n}\n.riq.accept {\n    background: @green;\n}\n::ng-deep {\n    .tooltip-inner {\n        background-color: @dkgrey;\n    }\n    .bs-tooltip-bottom .arrow:before {\n        border-bottom-color: @dkgrey;\n    }\n}\n\n/* NOTES */\ninput[type=\"button\"], button {\n  &.note-changes {\n    background: #3e73c9;\n    color: white;\n  }\n  &.note-setup {\n    background: #379dac;\n    color: white;\n  }\n  &.note-checkin {\n    background: #6c6c6c;\n    color: white;\n  }\n  &.note-pastdue {\n    background: @red;\n    color: white;\n  }\n  &.note-payment {\n    background: @green;\n    color: white;\n  }\n  &.note-disabled {\n    background: @dkgrey;\n    color: white;\n  }\n  &.note-preguntas {\n    background: @brpurple;\n    color: white;\n  }\n  &.note-rerun {\n    background: @orange;\n    color: white;\n  }\n  &.note-refund {\n    background: @yellow;\n    color: white;\n  }\n  &.note-review {\n    background: #b1639f;\n    color: white;\n  }\n}\n\ninput[type=\"button\"].note-label, .note-label {\n  color: white;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 400;\n  margin: 3px;\n  box-shadow: none;\n  &.note-changes {\n    background: #3e73c9;\n  }\n  &.note-setup {\n    background: #379dac;\n  }\n  &.note-checkin {\n    background: #6c6c6c;\n  }\n  &.note-pastdue {\n    background: @red;\n  }\n  &.note-payment {\n    background: @green;\n  }\n  &.note-disabled {\n    background: @dkgrey;\n  }\n  &.note-preguntas {\n    background: @brpurple;\n  }\n  &.note-rerun {\n    background: @orange;\n  }\n  &.note-refund {\n    background: @yellow;\n  }\n  &.note-review {\n    background: #b1639f;\n  }\n}\n\ni {\n  &.note-changes {\n    color: #3e73c9;\n  }\n  &.note-setup {\n    color: #379dac;\n  }\n  &.note-checkin {\n    color: #6c6c6c;\n  }\n  &.note-pastdue {\n    color: @red;\n  }\n  &.note-payment {\n    color: @green;\n  }\n  &.note-disabled {\n    color: @dkgrey;\n  }\n  &.note-preguntas {\n    color: @brpurple;\n  }\n  &.note-rerun {\n    color: @orange;\n  }\n  &.note-refund {\n    color: @yellow;\n  }\n  &.note-review {\n    color: #b1639f;\n  }\n}\n\n/* MISCELLANEOUS */\n.collapse-link {\n    font-size: 12px;\n    font-weight: 700;\n    color: @brblue;\n}\n\n/* PRINT STYLES */\n@media print {\n  body {\n    background: white !important;\n  }\n  header {\n    position: relative !important;\n  }\n  nav, .logo-holder img, .search-bar, .quick-nav {\n    display: none;\n  }\n  main {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  .logo-holder {\n    background: url('assets/images/ResIQ_Logo_Grey.png') no-repeat center white !important;\n    background-size: contain !important;\n    margin-left: 10px;\n  }\n  .w-container {\n    max-width: 100% !important;\n  }\n  .screening-report .header {\n    border-width: 5px 0px !important;\n    border-color: black !important;\n    border-style: solid !important;\n    background: none !important;\n    color: black !important;\n  }\n  h4 {\n    padding-left: 20px !important;\n    border-bottom: 1px solid black !important;\n    background: none !important;\n    color: black !important;\n  }\n  h5 {\n    background: #efefef !important;\n  }\n}\n\napp-address-input{\n  width:100%;\n}\n\n\n// @keyframes pulse {\n//   0% {\n//       opacity: 1;\n//       // color: black\n//   }\n//   50% {\n//       opacity: 1;\n//       // background-color: rgba(18,161,5,0.2);\n//       color : rgb(127, 230, 118);\n//       text-shadow: 0px 0px 15px rgba(18,161,5);\n//   }\n//   100% {\n//       opacity: 1;\n//       color: black;\n//   }\n// }\n\n\n@keyframes pulse {\n  0% {\n      opacity: 0.5;\n  }\n  50% {\n      opacity: 1;\n      color : rgba(127, 230, 118,0.9);\n      text-shadow: 0px 0px 20px rgba(18,161,5,1);\n  }\n  100% {\n      opacity: 1;\n      color: black;\n  }\n}\n\n.pulsing {\n  animation: pulse 3s;\n  animation-direction: alternate;\n}\n.residentIQ{\n  .pulsing;\n}\n\n.form-label {\n  padding-top: calc(.375rem + 1px);\n  padding-bottom: calc(.375rem + 1px);\n  padding-left: 15px;\n}\n\n// SOP assistant highlight glow\n@keyframes sop-highlight-glow {\n  0%, 100% { box-shadow: 0 0 15px 12px  rgba(29,0,249,0.3); }\n  50%      { box-shadow: 0 0 36px 13px rgba(29,0,249,0.8); }\n}\n\n@keyframes sop-highlight-fade-in {\n  from { opacity: 0; outline-color: transparent; box-shadow: none; }\n  to   { opacity: 1; }\n}\n\n@keyframes sop-highlight-fade-out {\n  from { opacity: 1; }\n  to   { opacity: 0; outline-color: transparent; box-shadow: none; }\n}\n\n.sop-highlight {\n  animation: sop-highlight-fade-in 0.4s ease-out, sop-highlight-glow 1s ease-in-out 0.4s infinite;\n  outline: 2px solid rgba(124, 109, 240, 0.7);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.sop-highlight-out {\n  animation: sop-highlight-fade-out 0.5s ease-in forwards;\n  outline: 2px solid rgba(124, 109, 240, 0.7);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n// @keyframes sop-highlight-glow {\n//   0%, 100% { box-shadow: 0 0 15px 12px  rgba(29,0,249,0.3); }\n//   50%      { box-shadow: 0 0 36px 13px rgba(29,0,249,0.8); }\n// }\n\n// .sop-highlight {\n//   animation: sop-highlight-glow 1.5s ease-in-out infinite;\n//   outline: 1px solid rgba(0,51,255,0.2);\n//   outline-offset: 3px;\n//   border-radius: 12px;\n// }","@import '../styles.less';\n\n@rd:#ec6f6f;\n@yw:#fae9af;\n@bl:#afcefa;\n@brd:#a0c2f1;\n.scrollable{\n    max-height:700px;\n    height: auto;\n    overflow-y: auto;\n    th {\n        text-align: left;\n        z-index: 1;\n        top: 0;\n        position: sticky;\n        background-color: white;\n      }\n}\n\ntable{\n    width: 99%;\n    &.center{\n        text-align: center;\n    }     \n}\nth{\n    font-weight: 600;\n    padding: 7px 5px;\n    color: #4b58a6;    \n}\ntr{\n    border-bottom: 1px solid #e7ebeb;\n    margin: 1%;\n    td{\n        padding:.3%;\n    };\n    &.invalid{\n        background-color: @red;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
